import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { color } from './helpers/variables';
import { dynamicFontSize, ellipsis } from './helpers/mixins';

export const SubHeading = styled.p`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2px;
  color: ${props => (props.color ? props.color : color.grey)};
  margin: ${props => (props.margin ? props.margin : '0 0 .5em')};

  ${props =>
    props.uppercase &&
    css`
      text-transform: uppercase;
    `}
  ${props =>
    props.small &&
    css`
      ${dynamicFontSize(10, 13)};
      ${ellipsis};
    `};
  ${props =>
    props.productPage &&
    css`
      display: inline-block;
      margin: 0 0 10px;
      font-size: 13px;
    `}
  ${props =>
    props.productPageMoble &&
    css`
      display: inline-block;
      margin: 0 0 5px;
      font-size: 11px;
    `}
`;

SubHeading.p = SubHeading;
SubHeading.link = SubHeading.withComponent(Link).extend`
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
SubHeading.h1 = SubHeading.withComponent('h1');
SubHeading.h2 = SubHeading.withComponent('h2');
SubHeading.h3 = SubHeading.withComponent('h3');
SubHeading.h4 = SubHeading.withComponent('h4');
SubHeading.h5 = SubHeading.withComponent('h5');
SubHeading.h6 = SubHeading.withComponent('h6');



// WEBPACK FOOTER //
// ./src/styles/SubHeading.js